import request from "@/utils/request";

export default {
  // 发送注册验证码
  getYZM(opt) {
    const params = {
      ...opt,
    };
    return request.get("/user/sendemail/register", {
      params: params,
    });
  },
  //注册
  register(postData) {
    return request.post("/user/register", postData);
  },
  //登录
  login(postData) {
    return request.post("/auth/userlogin2", postData);
  },
  //发送找回验证码
  getFindPasswordYZM(opt) {
    const params = {
      ...opt,
    };
    return request.get("/user/sendemail/findpassword", {
      params: params,
    });
  },
  //找回密码
  findPassword(postData) {
    return request.post("/user/setpassword", postData);
  },
  //退出登录
  logout(postData) {
    return request.post("/auth/userlogout2", postData);
  },
  //通过code获取token
  getTokenAccordingToCode(opt) {
    const params = {
      ...opt,
    };
    return request.get("/wx/queryTokenAccordingToCode", {
      params: params,
    });
  },
};
